import { createContext, useContext, type ReactNode } from 'react';

type BackendHealthContextValue = {
  isBackendUp: boolean;
};

const BackendHealthContext = createContext<BackendHealthContextValue>({ isBackendUp: true });

export function BackendHealthProvider({ children }: { children: ReactNode }) {
  return (
    <BackendHealthContext.Provider value={{ isBackendUp: true }}>
      {children}
    </BackendHealthContext.Provider>
  );
}

export function useBackendHealth() {
  return useContext(BackendHealthContext);
}
